export const CLEAN_TABS = [
  { id: "zaklad", label: "Základ" },
  { id: "vstupni", label: "Vstupní informace" },
  { id: "vypravitel", label: "Vypravitel" },
  { id: "zesnula", label: "Zesnulá osoba" },
  { id: "obrad", label: "Kremace / Pohřeb" },
  { id: "prevoz", label: "Převoz" },
  { id: "sluzby", label: "Výběr služeb" },
  { id: "kvetiny", label: "Květiny" },
  { id: "platba", label: "Platba / finance" },
  { id: "fotky", label: "Fotky" },
  { id: "rec", label: "Řeč / řečnice" },
  { id: "final", label: "Finální objednávka" },
];

export const EMPTY_ORDER = {
  id: "",
  orderId: "",
  zakazkaId: "",
  meta: {},
  stavKalendar: "potvrzeno",

  zaklad: {
    cisloZakazky: "",
    stavZakazky: "",
    typZakazky: "",
    datumSjednani: "",
    zesnuly: "",
    vypravitel: "",
    vyjezdRezim: "",
    vyjezdPlatce: "",
    zdravotniPojistovnaKod: "",
    zdravotniPojistovnaNazev: "",
    poznamka: "",
  },

  vstupniInformace: {
    jmenoZesnuleho: "",
    prijmeniZesnuleho: "",
    rodneCislo: "",
    datumNarozeni: "",
    datumUmrti: "",
    casUmrti: "",
    mistoUmrti: "",
    adresaUmrti: "",
    pitevna: "",
    datumProhlidky: "",
    casProhlidky: "",
    lekarJmeno: "",
    lekarTelefon: "",
    poznamka: "",
  },

  vypravitel: {
    jmeno: "",
    prijmeni: "",
    datumNarozeni: "",
    telefon: "",
    email: "",
    vztah: "",
    adresa: "",
    mesto: "",
    psc: "",
    poznamka: "",
  },

  zesnulaOsoba: {
    jmeno: "",
    prijmeni: "",
    rodneCislo: "",
    datumNarozeni: "",
    datumUmrti: "",
    casUmrti: "",
    mistoUmrti: "",
    adresaUmrti: "",
    trvaleBydliste: "",
    narodnost: "",
    stav: "",
    poznamka: "",
  },

  vyjezd: {
    jmenoZesnuleho: "",
    prijmeniZesnuleho: "",
    datumNarozeni: "",
    datumUmrti: "",
    casUmrti: "",
    adresaUmrti: "",
    fotkaOhledacihoListu: "",
    fotkaZesnuleho: "",
    vyjezdRezim: "",
    vyjezdPlatce: "",
    zdravotniPojistovnaKod: "",
    zdravotniPojistovnaNazev: "",
    zdravotniPojistovnaAdresa: "",
    zdravotniPojistovnaEmail: "",
    storageType: "",
    storagePlaceId: "",
    storagePlaceName: "",
    storageAddress: "",
    storageCity: "",
    storageNote: "",
    crew1: "",
    crew2: "",
    startAt: "",
    endAt: "",
    vehicleId: "",
    vehicleLabel: "",
    vehicleSpz: "",
    fakturaceSubjekt: "",
    fakturaceNazev: "",
    fakturaceAdresa: "",
    fakturaceEmail: "",
    poznamka: "",
  },

  prevoz: {
    typPrevozu: "",
    mistoOdvozu: "",
    adresaOdvozu: "",
    cilPrevozuTyp: "",
    cilPrevozuNazev: "",
    cilPrevozuAdresa: "",
    datumPrevozu: "",
    casPrevozu: "",
    posadka: "",
    vozidlo: "",
    km: "",
    trvaniMin: 60,
    roleAssignments: [],
    vehicleAssignments: [],
    navazujiciRodinnyPrevoz: false,
    pitvaUzavrena: false,
    kmRozpad: {
      pcrKm: "",
      pojistovnaKm: "",
      rodinaKm: "",
      pojistovnaKoeficient: "",
      pojistovnaKmVypocet: "",
      poznamka: "",
    },
    fakturaceRozpad: {
      pcr: {
        aktivni: false,
        subjekt: "Policie ČR",
        km: "",
        poznamka: "",
      },
      pojistovna: {
        aktivni: false,
        subjekt: "",
        km: "",
        koeficient: "",
        kmVypocet: "",
        poznamka: "",
      },
      rodina: {
        aktivni: false,
        subjekt: "Rodina",
        km: "",
        poznamka: "",
      },
    },
    externiFakturace: {
      pcr: {
        aktivni: false,
        cislo: "",
        datum: "",
          datumSplatnosti: "",
          odeslanoDne: "",
          stav: "",
        subjekt: "Policie ČR",
        adresa: "",
        email: "",
        sluzby: {
          vyjezd: true,
          prevozNaPitvu: true,
          navratNaFirmu: true,
        },
        kmZaklad: "",
        kmVypocet: "",
        castkaBezDph: "",
          castkaSDph: "",
        poznamka: "",
      },
      pojistovna: {
        aktivni: false,
        cislo: "",
        datum: "",
          datumSplatnosti: "",
          odeslanoDne: "",
          stav: "",
        subjekt: "",
        adresa: "",
        email: "",
        sluzby: {
          nalozenyPrevozNaPitvu: true,
          nalozenyPrevozZPitvy: true,
        },
        kmZaklad: "",
        koeficient: "",
        kmVypocet: "",
        castkaBezDph: "",
          castkaSDph: "",
        poznamka: "",
      },
    },
    rodinnaFakturace: {
      cislo: "",
      datum: "",
        datumSplatnosti: "",
        odeslanoDne: "",
        stav: "",
      subjekt: "Rodina",
      km: "",
      castkaBezDph: "",
        castkaSDph: "",
      vyjezdCenik: {
        pcrSazbaKm: "",
        pojistovnaSazbaKm: "",
        rodinaSazbaKm: "",
        pojistovnaKoeficientVychozi: "",
        pcrPausal: "",
        pojistovnaPausal: "",
        rodinaPausal: "",
        poznamka: "",
      },
      vyjezdVypocet: {
        pcrZakladKm: "",
        pojistovnaZakladKm: "",
        rodinaZakladKm: "",
        pcrKmVypocet: "",
        pojistovnaKmVypocet: "",
        rodinaKmVypocet: "",
        pcrCelkemBezDph: "",
        pojistovnaCelkemBezDph: "",
        rodinaCelkemBezDph: "",
        posledniPrepocet: "",
        poznamka: "",
      },
      etapy: {},
      poznamka: "",
    },
    poznamka: "",
  },

  obrad: {
    typ: "",
    datum: "",
    cas: "",
    misto: "",
    mistoAdresa: "",
    krematorium: "",
    krematoriumAdresa: "",
    hrbitov: "",
    hrbitovAdresa: "",
    recnik: "",
    hudba: "",
    roleAssignments: [],
    vehicleAssignments: [],
    poznamka: "",
  },

  sluzby: [],
  kvetiny: {
    objednano: false,
    dodavatel: "",
    typVazby: "",
    barva: "",
    stuhaText1: "",
    stuhaText2: "",
    stuhaBarva: "",
    poznamka: "",
    mnozstvi: 1,
    cenaBezDph: "",
    cenaSDph: "",
    dph: 21,
    items: [],
  },
  cenikOverrides: {},
  platba: {
    zalohovaPlatba: "",
    uhrazenoCelkem: "",
    zpusobUhrady: "",
    datumUhrady: "",
    poznamkaPlatba: "",
  },

  rec: {
    stav: "bez_podkladu",
    kontaktRodinaEmail: "",
    kontaktRodinaJmeno: "",
    sdileniPovoleno: false,
    sdileniToken: "",
    sdileniVytvoreno: "",
    sdileniExpirace: "",
    sdileniNaposledOdeslano: "",
    sdileniOdeslal: "",
    stavRodina: "neodeslano",
    potvrzenoRodinou: false,
    datumPotvrzeniRodinou: "",
    datumUzamceniRodinou: "",
    potvrzeniPoznamka: "",
    uzamcenoPoPotvrzeni: false,
    posledniUpravaRodinou: "",
    rodina: {
      partner: "",
      deti: "",
      vnucata: "",
      sourozenci: "",
      rodice: "",
      dalsi: "",
    },
    zivot: {
      puvod: "",
      detstvi: "",
      skola: "",
      prace: "",
      zajmy: "",
      hodnoty: "",
    },
    charakter: {
      povaha: "",
      vlastnosti: "",
      zvyky: "",
      vzpominky: "",
      urciteZminit: "",
    },
    citlive: {
      nezminovat: "",
      opatrne: "",
      poznamka: "",
    },
    forma: {
      delka: "",
      styl: "",
      nabozenskyTon: "",
      dulezityDuraz: "",
      zaver: "",
    },
    text: {
      poznamky: "",
      navrhReci: "",
    },
  },
};

export function deepClone(value) {
  try {
    return structuredClone(value);
  } catch {
    return JSON.parse(JSON.stringify(value));
  }
}


function __filled(value) {
  return String(value ?? "").trim() !== "";
}

function __pickFirstFilled(...values) {
  for (const value of values) {
    if (__filled(value)) return String(value).trim();
  }
  return "";
}

function __splitDateTime(value) {
  const raw = String(value || "").trim();
  if (!raw) return { date: "", time: "" };

  if (raw.includes("T")) {
    const [datePart, timePart = ""] = raw.split("T");
    return {
      date: String(datePart || "").slice(0, 10),
      time: String(timePart || "").slice(0, 5),
    };
  }

  if (raw.includes(" ")) {
    const parts = raw.split(" ");
    return {
      date: String(parts[0] || "").slice(0, 10),
      time: String(parts[1] || "").slice(0, 5),
    };
  }

  return {
    date: raw.slice(0, 10),
    time: "",
  };
}

function __toNumberSafe(value) {
  const raw = String(value ?? "").replace(",", ".").trim();
  if (!raw) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

function __toMoneyLike(value) {
  const n = __toNumberSafe(value);
  return n ? n.toFixed(2) : "";
}

function __roundKmLike(value) {
  const n = __toNumberSafe(value);
  return n ? String(Math.round(n * 100) / 100) : "";
}

export function normalizeOrderAfterLoad(orderLike, forcedId = "") {
  const base = ensureOrderIds(
    deepClone(orderLike && typeof orderLike === "object" ? orderLike : EMPTY_ORDER),
    forcedId
  );

  const zaklad = { ...(base.zaklad || {}) };
  const vstupniInformace = { ...(base.vstupniInformace || {}) };
  const zesnulaOsoba = { ...(base.zesnulaOsoba || {}) };
  const vypravitel = { ...(base.vypravitel || {}) };
  const vyjezd = { ...(base.vyjezd || {}) };
  const prevoz = {
    ...(base.prevoz || {}),
    kmRozpad: { ...(((base.prevoz || {}).kmRozpad) || {}) },
    fakturaceRozpad: { ...(((base.prevoz || {}).fakturaceRozpad) || {}) },
    externiFakturace: { ...(((base.prevoz || {}).externiFakturace) || {}) },
    rodinnaFakturace: { ...(((base.prevoz || {}).rodinnaFakturace) || {}) },
      vyjezdCenik: { ...(((base.prevoz || {}).vyjezdCenik) || {}) },
      vyjezdVypocet: { ...(((base.prevoz || {}).vyjezdVypocet) || {}) },
    etapy: { ...(((base.prevoz || {}).etapy) || {}) },
  };

  const startInfo = __splitDateTime(vyjezd.startAt);
  const crewJoined = [vyjezd.crew1, vyjezd.crew2].map((x) => String(x || "").trim()).filter(Boolean).join(" + ");
  const fullName = [vyjezd.jmenoZesnuleho, vyjezd.prijmeniZesnuleho].map((x) => String(x || "").trim()).filter(Boolean).join(" ").trim();
  const vypravitelFullName = [vypravitel.jmeno, vypravitel.prijmeni].map((x) => String(x || "").trim()).filter(Boolean).join(" ").trim();

  const maVyjezdData = [
    vyjezd.jmenoZesnuleho,
    vyjezd.prijmeniZesnuleho,
    vyjezd.datumUmrti,
    vyjezd.adresaUmrti,
    vyjezd.storagePlaceName,
    vyjezd.startAt,
    vyjezd.vyjezdRezim,
  ].some(__filled);

  // vstupni informace
  if (!__filled(vstupniInformace.jmenoZesnuleho)) {
    vstupniInformace.jmenoZesnuleho = __pickFirstFilled(vyjezd.jmenoZesnuleho, zesnulaOsoba.jmeno);
  }
  if (!__filled(vstupniInformace.prijmeniZesnuleho)) {
    vstupniInformace.prijmeniZesnuleho = __pickFirstFilled(vyjezd.prijmeniZesnuleho, zesnulaOsoba.prijmeni);
  }
  if (!__filled(vstupniInformace.datumNarozeni)) {
    vstupniInformace.datumNarozeni = __pickFirstFilled(vyjezd.datumNarozeni, zesnulaOsoba.datumNarozeni);
  }
  if (!__filled(vstupniInformace.datumUmrti)) {
    vstupniInformace.datumUmrti = __pickFirstFilled(vyjezd.datumUmrti, zesnulaOsoba.datumUmrti);
  }
  if (!__filled(vstupniInformace.casUmrti)) {
    vstupniInformace.casUmrti = __pickFirstFilled(vyjezd.casUmrti, zesnulaOsoba.casUmrti, startInfo.time);
  }
  if (!__filled(vstupniInformace.adresaUmrti)) {
    vstupniInformace.adresaUmrti = __pickFirstFilled(vyjezd.adresaUmrti, zesnulaOsoba.adresaUmrti);
  }
  if (!__filled(vstupniInformace.mistoUmrti)) {
    vstupniInformace.mistoUmrti = __pickFirstFilled(prevoz.mistoOdvozu, zesnulaOsoba.mistoUmrti, (maVyjezdData ? "Místo úmrtí" : ""));
  }

  // zesnulá osoba
  if (!__filled(zesnulaOsoba.jmeno)) {
    zesnulaOsoba.jmeno = __pickFirstFilled(vyjezd.jmenoZesnuleho, vstupniInformace.jmenoZesnuleho);
  }
  if (!__filled(zesnulaOsoba.prijmeni)) {
    zesnulaOsoba.prijmeni = __pickFirstFilled(vyjezd.prijmeniZesnuleho, vstupniInformace.prijmeniZesnuleho);
  }
  if (!__filled(zesnulaOsoba.datumNarozeni)) {
    zesnulaOsoba.datumNarozeni = __pickFirstFilled(vyjezd.datumNarozeni, vstupniInformace.datumNarozeni);
  }
  if (!__filled(zesnulaOsoba.datumUmrti)) {
    zesnulaOsoba.datumUmrti = __pickFirstFilled(vyjezd.datumUmrti, vstupniInformace.datumUmrti);
  }
  if (!__filled(zesnulaOsoba.casUmrti)) {
    zesnulaOsoba.casUmrti = __pickFirstFilled(vyjezd.casUmrti, vstupniInformace.casUmrti, startInfo.time);
  }
  if (!__filled(zesnulaOsoba.adresaUmrti)) {
    zesnulaOsoba.adresaUmrti = __pickFirstFilled(vyjezd.adresaUmrti, vstupniInformace.adresaUmrti);
  }
  if (!__filled(zesnulaOsoba.mistoUmrti)) {
    zesnulaOsoba.mistoUmrti = __pickFirstFilled(vstupniInformace.mistoUmrti, prevoz.mistoOdvozu);
  }

  // vypravitel
  if (!__filled(zaklad.vypravitel)) {
    zaklad.vypravitel = __pickFirstFilled(vypravitelFullName);
  }

  // základ
  if (!__filled(zaklad.typZakazky) && maVyjezdData) {
    zaklad.typZakazky = "vyjezd";
  }
  if (!__filled(zaklad.zesnuly)) {
    zaklad.zesnuly = __pickFirstFilled(
      fullName,
      [vstupniInformace.jmenoZesnuleho, vstupniInformace.prijmeniZesnuleho].filter(Boolean).join(" ").trim(),
      [zesnulaOsoba.jmeno, zesnulaOsoba.prijmeni].filter(Boolean).join(" ").trim(),
    )
  }
  if (!__filled(zaklad.datumSjednani)) {
    zaklad.datumSjednani = __pickFirstFilled(startInfo.date, vyjezd.datumUmrti, vstupniInformace.datumUmrti, zesnulaOsoba.datumUmrti)
  }
  if (!__filled(zaklad.vyjezdRezim)) {
    zaklad.vyjezdRezim = __pickFirstFilled(vyjezd.vyjezdRezim)
  }
  if (!__filled(zaklad.vyjezdPlatce)) {
    zaklad.vyjezdPlatce = __pickFirstFilled(vyjezd.vyjezdPlatce)
  }
  if (!__filled(zaklad.zdravotniPojistovnaKod)) {
    zaklad.zdravotniPojistovnaKod = __pickFirstFilled(vyjezd.zdravotniPojistovnaKod)
  }
  if (!__filled(zaklad.zdravotniPojistovnaNazev)) {
    zaklad.zdravotniPojistovnaNazev = __pickFirstFilled(vyjezd.zdravotniPojistovnaNazev)
  }

  // obřad
  const obrad = { ...(base.obrad || {}) };

  if (!__filled(obrad.datum)) {
    obrad.datum = __pickFirstFilled(prevoz.datumPrevozu, zaklad.datumSjednani);
  }
  if (!__filled(obrad.cas)) {
    obrad.cas = __pickFirstFilled(prevoz.casPrevozu, startInfo.time);
  }
  if (!__filled(obrad.misto) && __filled(prevoz.cilPrevozuNazev)) {
    obrad.misto = __pickFirstFilled(prevoz.cilPrevozuNazev);
  }
  if (!__filled(obrad.mistoAdresa) && __filled(prevoz.cilPrevozuAdresa)) {
    obrad.mistoAdresa = __pickFirstFilled(prevoz.cilPrevozuAdresa);
  }

  // převoz – doplnit až po otevření
  if (maVyjezdData) {
    if (!__filled(prevoz.typPrevozu)) {
      prevoz.typPrevozu = "vyjezd";
    }
    if (!__filled(prevoz.mistoOdvozu)) {
      prevoz.mistoOdvozu = __pickFirstFilled(vstupniInformace.mistoUmrti, zesnulaOsoba.mistoUmrti, "Místo úmrtí");
    }
    if (!__filled(prevoz.adresaOdvozu)) {
      prevoz.adresaOdvozu = __pickFirstFilled(vyjezd.adresaUmrti, vstupniInformace.adresaUmrti, zesnulaOsoba.adresaUmrti);
    }
    if (!__filled(prevoz.cilPrevozuTyp)) {
      prevoz.cilPrevozuTyp = "pitva_patologie";
    }
    if (!__filled(prevoz.cilPrevozuNazev)) {
      prevoz.cilPrevozuNazev = __pickFirstFilled(vyjezd.storagePlaceName);
    }
    if (!__filled(prevoz.cilPrevozuAdresa)) {
      prevoz.cilPrevozuAdresa = __pickFirstFilled(vyjezd.storageAddress);
    }
    if (!__filled(prevoz.datumPrevozu)) {
      prevoz.datumPrevozu = __pickFirstFilled(startInfo.date, vyjezd.datumUmrti);
    }
    if (!__filled(prevoz.casPrevozu)) {
      prevoz.casPrevozu = __pickFirstFilled(startInfo.time, vyjezd.casUmrti);
    }
    if (!__filled(prevoz.posadka)) {
      prevoz.posadka = __pickFirstFilled(crewJoined);
    }
    if (!__filled(prevoz.vozidlo)) {
      prevoz.vozidlo = __pickFirstFilled(vyjezd.vehicleLabel, vyjezd.vehicleId);
    }

    const vyjezdPlatce = __pickFirstFilled(vyjezd.vyjezdPlatce, zaklad.vyjezdPlatce);
    const pojNazev = __pickFirstFilled(vyjezd.zdravotniPojistovnaNazev, zaklad.zdravotniPojistovnaNazev);
    const pojKod = __pickFirstFilled(vyjezd.zdravotniPojistovnaKod, zaklad.zdravotniPojistovnaKod);

    prevoz.kmRozpad = {
      ...(prevoz.kmRozpad || {}),
      pojistovnaKoeficient: __pickFirstFilled(
        prevoz?.kmRozpad?.pojistovnaKoeficient,
        vyjezd?.externiFakturace?.pojistovna?.koeficient
      ),
    };

    prevoz.fakturaceRozpad = {
      ...(prevoz.fakturaceRozpad || {}),
      pcr: {
        ...((prevoz.fakturaceRozpad || {}).pcr || {}),
        subjekt: __pickFirstFilled(
          prevoz?.fakturaceRozpad?.pcr?.subjekt,
          "Policie ČR"
        ),
        aktivni:
          typeof ((prevoz.fakturaceRozpad || {}).pcr || {}).aktivni === "boolean"
            ? ((prevoz.fakturaceRozpad || {}).pcr || {}).aktivni
            : (vyjezdPlatce === "pcr"),
      },
      pojistovna: {
        ...((prevoz.fakturaceRozpad || {}).pojistovna || {}),
        subjekt: __pickFirstFilled(
          prevoz?.fakturaceRozpad?.pojistovna?.subjekt,
          pojNazev
        ),
        koeficient: __pickFirstFilled(
          prevoz?.fakturaceRozpad?.pojistovna?.koeficient,
          prevoz?.kmRozpad?.pojistovnaKoeficient,
          vyjezd?.externiFakturace?.pojistovna?.koeficient
        ),
        aktivni:
          typeof ((prevoz.fakturaceRozpad || {}).pojistovna || {}).aktivni === "boolean"
            ? ((prevoz.fakturaceRozpad || {}).pojistovna || {}).aktivni
            : (vyjezdPlatce === "pojistovna"),
      },
      rodina: {
        ...((prevoz.fakturaceRozpad || {}).rodina || {}),
        subjekt: __pickFirstFilled(
          prevoz?.fakturaceRozpad?.rodina?.subjekt,
          "Rodina"
        ),
        aktivni:
          typeof ((prevoz.fakturaceRozpad || {}).rodina || {}).aktivni === "boolean"
            ? ((prevoz.fakturaceRozpad || {}).rodina || {}).aktivni
            : (!!vyjezdPlatce && vyjezdPlatce !== "pcr" && vyjezdPlatce !== "pojistovna"),
      },
    };

    prevoz.externiFakturace = {
      ...(prevoz.externiFakturace || {}),
      pcr: {
        ...((prevoz.externiFakturace || {}).pcr || {}),
        subjekt: __pickFirstFilled(
          prevoz?.externiFakturace?.pcr?.subjekt,
          vyjezd?.externiFakturace?.pcr?.subjekt,
          "Policie ČR"
        ),
        adresa: __pickFirstFilled(
          prevoz?.externiFakturace?.pcr?.adresa,
          vyjezd?.externiFakturace?.pcr?.adresa,
          vyjezd?.fakturaceAdresa
        ),
        email: __pickFirstFilled(
          prevoz?.externiFakturace?.pcr?.email,
          vyjezd?.externiFakturace?.pcr?.email,
          vyjezd?.fakturaceEmail
        ),
        cislo: __pickFirstFilled(
          prevoz?.externiFakturace?.pcr?.cislo,
          vyjezd?.externiFakturace?.pcr?.cislo
        ),
        datum: __pickFirstFilled(
          prevoz?.externiFakturace?.pcr?.datum,
          vyjezd?.externiFakturace?.pcr?.datum,
          prevoz.datumPrevozu
        ),
        aktivni:
          typeof ((prevoz.externiFakturace || {}).pcr || {}).aktivni === "boolean"
            ? ((prevoz.externiFakturace || {}).pcr || {}).aktivni
            : (vyjezdPlatce === "pcr"),
      },
      pojistovna: {
        ...((prevoz.externiFakturace || {}).pojistovna || {}),
        subjekt: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.subjekt,
          vyjezd?.externiFakturace?.pojistovna?.subjekt,
          pojNazev
        ),
        adresa: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.adresa,
          vyjezd?.externiFakturace?.pojistovna?.adresa,
          vyjezd?.zdravotniPojistovnaAdresa
        ),
        email: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.email,
          vyjezd?.externiFakturace?.pojistovna?.email,
          vyjezd?.zdravotniPojistovnaEmail
        ),
        cislo: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.cislo,
          vyjezd?.externiFakturace?.pojistovna?.cislo
        ),
        datum: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.datum,
          vyjezd?.externiFakturace?.pojistovna?.datum,
          prevoz.datumPrevozu
        ),
        koeficient: __pickFirstFilled(
          prevoz?.externiFakturace?.pojistovna?.koeficient,
          vyjezd?.externiFakturace?.pojistovna?.koeficient,
          prevoz?.kmRozpad?.pojistovnaKoeficient
        ),
        aktivni:
          typeof ((prevoz.externiFakturace || {}).pojistovna || {}).aktivni === "boolean"
            ? ((prevoz.externiFakturace || {}).pojistovna || {}).aktivni
            : (vyjezdPlatce === "pojistovna"),
      },
    };

    prevoz.rodinnaFakturace = {
      ...(prevoz.rodinnaFakturace || {}),
      subjekt: __pickFirstFilled(
        prevoz?.rodinnaFakturace?.subjekt,
        "Rodina"
      ),
      datum: __pickFirstFilled(
        prevoz?.rodinnaFakturace?.datum,
        prevoz.datumPrevozu
      ),
    };

      prevoz.vyjezdCenik = {
        ...(prevoz.vyjezdCenik || {}),
        pojistovnaKoeficientVychozi: __pickFirstFilled(
          prevoz?.vyjezdCenik?.pojistovnaKoeficientVychozi,
          prevoz?.kmRozpad?.pojistovnaKoeficient,
          prevoz?.externiFakturace?.pojistovna?.koeficient,
          vyjezd?.externiFakturace?.pojistovna?.koeficient
        ),
        pcrSazbaKm: __pickFirstFilled(
          prevoz?.vyjezdCenik?.pcrSazbaKm
        ),
        pojistovnaSazbaKm: __pickFirstFilled(
          prevoz?.vyjezdCenik?.pojistovnaSazbaKm
        ),
        rodinaSazbaKm: __pickFirstFilled(
          prevoz?.vyjezdCenik?.rodinaSazbaKm
        ),
        pcrPausal: __pickFirstFilled(
          prevoz?.vyjezdCenik?.pcrPausal
        ),
        pojistovnaPausal: __pickFirstFilled(
          prevoz?.vyjezdCenik?.pojistovnaPausal
        ),
        rodinaPausal: __pickFirstFilled(
          prevoz?.vyjezdCenik?.rodinaPausal
        ),
      };

      prevoz.vyjezdVypocet = {
        ...(prevoz.vyjezdVypocet || {}),
        pcrZakladKm: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pcrZakladKm,
          prevoz?.externiFakturace?.pcr?.kmZaklad,
          prevoz?.kmRozpad?.pcrKm
        ),
        pojistovnaZakladKm: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pojistovnaZakladKm,
          prevoz?.externiFakturace?.pojistovna?.kmZaklad,
          prevoz?.kmRozpad?.pojistovnaKm
        ),
        rodinaZakladKm: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.rodinaZakladKm,
          prevoz?.rodinnaFakturace?.km,
          prevoz?.kmRozpad?.rodinaKm
        ),
        pcrKmVypocet: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pcrKmVypocet,
          prevoz?.externiFakturace?.pcr?.kmVypocet,
          prevoz?.kmRozpad?.pcrKm
        ),
        pojistovnaKmVypocet: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pojistovnaKmVypocet,
          prevoz?.externiFakturace?.pojistovna?.kmVypocet,
          prevoz?.kmRozpad?.pojistovnaKmVypocet
        ),
        rodinaKmVypocet: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.rodinaKmVypocet,
          prevoz?.rodinnaFakturace?.km,
          prevoz?.kmRozpad?.rodinaKm
        ),
        pcrCelkemBezDph: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pcrCelkemBezDph,
          prevoz?.externiFakturace?.pcr?.castkaBezDph
        ),
        pojistovnaCelkemBezDph: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.pojistovnaCelkemBezDph,
          prevoz?.externiFakturace?.pojistovna?.castkaBezDph
        ),
        rodinaCelkemBezDph: __pickFirstFilled(
          prevoz?.vyjezdVypocet?.rodinaCelkemBezDph,
          prevoz?.rodinnaFakturace?.castkaBezDph
        ),
      };

      const pcrZakladKmNum = __toNumberSafe(
        prevoz?.vyjezdVypocet?.pcrZakladKm || prevoz?.kmRozpad?.pcrKm
      );
      const pojistovnaZakladKmNum = __toNumberSafe(
        prevoz?.vyjezdVypocet?.pojistovnaZakladKm || prevoz?.kmRozpad?.pojistovnaKm
      );
      const rodinaZakladKmNum = __toNumberSafe(
        prevoz?.vyjezdVypocet?.rodinaZakladKm || prevoz?.kmRozpad?.rodinaKm || prevoz?.rodinnaFakturace?.km
      );

      const pcrSazbaKmNum = __toNumberSafe(prevoz?.vyjezdCenik?.pcrSazbaKm);
      const pojistovnaSazbaKmNum = __toNumberSafe(prevoz?.vyjezdCenik?.pojistovnaSazbaKm);
      const rodinaSazbaKmNum = __toNumberSafe(prevoz?.vyjezdCenik?.rodinaSazbaKm);

      const pojistovnaKoefNum = __toNumberSafe(
        prevoz?.kmRozpad?.pojistovnaKoeficient ||
        prevoz?.vyjezdCenik?.pojistovnaKoeficientVychozi ||
        prevoz?.externiFakturace?.pojistovna?.koeficient
      ) || 1;

      const pcrPausalNum = __toNumberSafe(prevoz?.vyjezdCenik?.pcrPausal);
      const pojistovnaPausalNum = __toNumberSafe(prevoz?.vyjezdCenik?.pojistovnaPausal);
      const rodinaPausalNum = __toNumberSafe(prevoz?.vyjezdCenik?.rodinaPausal);

      const pcrKmVypocetNum = pcrZakladKmNum;
      const pojistovnaKmVypocetNum = pojistovnaZakladKmNum * pojistovnaKoefNum;
      const rodinaKmVypocetNum = rodinaZakladKmNum;

      const pcrCelkemBezDphNum = (pcrKmVypocetNum * pcrSazbaKmNum) + pcrPausalNum;
      const pojistovnaCelkemBezDphNum = (pojistovnaKmVypocetNum * pojistovnaSazbaKmNum) + pojistovnaPausalNum;
      const rodinaCelkemBezDphNum = (rodinaKmVypocetNum * rodinaSazbaKmNum) + rodinaPausalNum;

      prevoz.vyjezdVypocet = {
        ...(prevoz.vyjezdVypocet || {}),
        pcrZakladKm: __roundKmLike(pcrZakladKmNum),
        pojistovnaZakladKm: __roundKmLike(pojistovnaZakladKmNum),
        rodinaZakladKm: __roundKmLike(rodinaZakladKmNum),
        pcrKmVypocet: __roundKmLike(pcrKmVypocetNum),
        pojistovnaKmVypocet: __roundKmLike(pojistovnaKmVypocetNum),
        rodinaKmVypocet: __roundKmLike(rodinaKmVypocetNum),
        pcrCelkemBezDph: __toMoneyLike(pcrCelkemBezDphNum),
        pojistovnaCelkemBezDph: __toMoneyLike(pojistovnaCelkemBezDphNum),
        rodinaCelkemBezDph: __toMoneyLike(rodinaCelkemBezDphNum),
        posledniPrepocet: new Date().toISOString(),
      };

      prevoz.externiFakturace = {
        ...(prevoz.externiFakturace || {}),
        pcr: {
          ...((prevoz.externiFakturace || {}).pcr || {}),
          kmZaklad: __roundKmLike(pcrZakladKmNum),
          kmVypocet: __roundKmLike(pcrKmVypocetNum),
          castkaBezDph: __pickFirstFilled(
            prevoz?.externiFakturace?.pcr?.castkaBezDph,
            __toMoneyLike(pcrCelkemBezDphNum)
          ),
        },
        pojistovna: {
          ...((prevoz.externiFakturace || {}).pojistovna || {}),
          kmZaklad: __roundKmLike(pojistovnaZakladKmNum),
          koeficient: __pickFirstFilled(
            prevoz?.externiFakturace?.pojistovna?.koeficient,
            __roundKmLike(pojistovnaKoefNum)
          ),
          kmVypocet: __roundKmLike(pojistovnaKmVypocetNum),
          castkaBezDph: __pickFirstFilled(
            prevoz?.externiFakturace?.pojistovna?.castkaBezDph,
            __toMoneyLike(pojistovnaCelkemBezDphNum)
          ),
        },
      };

      prevoz.rodinnaFakturace = {
        ...(prevoz.rodinnaFakturace || {}),
        km: __pickFirstFilled(
          prevoz?.rodinnaFakturace?.km,
          __roundKmLike(rodinaZakladKmNum)
        ),
        castkaBezDph: __pickFirstFilled(
          prevoz?.rodinnaFakturace?.castkaBezDph,
          __toMoneyLike(rodinaCelkemBezDphNum)
        ),
      };

    if (!__filled(zaklad.vypravitel)) {
      zaklad.vypravitel = __pickFirstFilled(
        [base?.vypravitel?.jmeno, base?.vypravitel?.prijmeni].filter(Boolean).join(" ").trim()
      );
    }

    if (!__filled(zaklad.zdravotniPojistovnaKod)) {
      zaklad.zdravotniPojistovnaKod = __pickFirstFilled(pojKod);
    }
    if (!__filled(zaklad.zdravotniPojistovnaNazev)) {
      zaklad.zdravotniPojistovnaNazev = __pickFirstFilled(pojNazev);
    }
  }

  return ensureOrderIds({
    ...base,
    zaklad,
    vstupniInformace,
    vypravitel,
    zesnulaOsoba,
    vyjezd,
    prevoz,
    obrad,
  }, forcedId);
}


export function ensureOrderIds(orderLike, forcedId = "") {
  const src = orderLike && typeof orderLike === "object" ? deepClone(orderLike) : {};
  const id =
    String(
      forcedId ||
        src.orderId ||
        src.zakazkaId ||
        src.id ||
        src?.meta?.orderId ||
        src?.meta?.id ||
        ""
    ).trim();

  if (!id) return src;

  src.id = id;
  src.orderId = id;
  src.zakazkaId = id;
  src.meta = { ...(src.meta || {}), orderId: id, id };

  return src;
}

export function createEmptyOrder(forcedId = "") {
  return ensureOrderIds(deepClone(EMPTY_ORDER), forcedId);
}

export function mergeOrder(base, patch, forcedId = "") {
  const a = base && typeof base === "object" ? base : {};
  const b = patch && typeof patch === "object" ? patch : {};

  const out = {
    ...a,
    ...b,
    meta: {
      ...(a.meta || {}),
      ...(b.meta || {}),
    },
    zaklad: {
      ...(a.zaklad || {}),
      ...(b.zaklad || {}),
    },
    vstupniInformace: {
      ...(a.vstupniInformace || {}),
      ...(b.vstupniInformace || {}),
    },
    vypravitel: {
      ...(a.vypravitel || {}),
      ...(b.vypravitel || {}),
    },
    zesnulaOsoba: {
      ...(a.zesnulaOsoba || {}),
      ...(b.zesnulaOsoba || {}),
    },
    vyjezd: {
      ...(a.vyjezd || {}),
      ...(b.vyjezd || {}),
    },
    prevoz: {
      ...(a.prevoz || {}),
      ...(b.prevoz || {}),
      etapy: {
        ...((a.prevoz || {}).etapy || {}),
        ...((b.prevoz || {}).etapy || {}),
      },
    },
    obrad: {
      ...(a.obrad || {}),
      ...(b.obrad || {}),
    },
    kvetiny: {
      ...(a.kvetiny || {}),
      ...(b.kvetiny || {}),
      items: Array.isArray(b?.kvetiny?.items)
        ? b.kvetiny.items
        : Array.isArray(a?.kvetiny?.items)
          ? a.kvetiny.items
          : [],
    },
    platba: {
      ...(a.platba || {}),
      ...(b.platba || {}),
    },
    cenikOverrides: {
      ...(a.cenikOverrides || {}),
      ...(b.cenikOverrides || {}),
    },
    sluzby: Array.isArray(b.sluzby)
      ? b.sluzby
      : Array.isArray(a.sluzby)
        ? a.sluzby
        : [],
    rec: {
      ...(a.rec || {}),
      ...(b.rec || {}),
      stav:
        (b.rec && b.rec.stav) ||
        (a.rec && a.rec.stav) ||
        "bez_podkladu",
      stavRodina:
        (b.rec && b.rec.stavRodina) ||
        (a.rec && a.rec.stavRodina) ||
        "neodeslano",
      rodina: {
        ...(((a.rec || {}).rodina) || {}),
        ...(((b.rec || {}).rodina) || {}),
      },
      zivot: {
        ...(((a.rec || {}).zivot) || {}),
        ...(((b.rec || {}).zivot) || {}),
      },
      charakter: {
        ...(((a.rec || {}).charakter) || {}),
        ...(((b.rec || {}).charakter) || {}),
      },
      citlive: {
        ...(((a.rec || {}).citlive) || {}),
        ...(((b.rec || {}).citlive) || {}),
      },
      forma: {
        ...(((a.rec || {}).forma) || {}),
        ...(((b.rec || {}).forma) || {}),
      },
      text: {
        ...(((a.rec || {}).text) || {}),
        ...(((b.rec || {}).text) || {}),
      },
    },
  };
  return ensureOrderIds(out, forcedId);
}
